import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppFloat from '../../components/feature/WhatsAppFloat';
import ComoVenderHero from './components/ComoVenderHero';
import PasosDetallados from './components/PasosDetallados';
import CalculadorPrecio from './components/CalculadorPrecio';
import ConsejosSection from './components/ConsejosSection';
import FormularioContacto from './components/FormularioContacto';
import CtaFinal from './components/CtaFinal';
import { updatePageSEO } from '../../utils/seoConfig';

const ComoVenderPage = () => {
  useEffect(() => {
    updatePageSEO('comoVender');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <ComoVenderHero />
        <PasosDetallados />
        <CalculadorPrecio />
        <ConsejosSection />
        <FormularioContacto />
        <CtaFinal />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default ComoVenderPage;
